export const ActionTypes = {
  SET_HELD_OBJECT: "SET_HELD_OBJECT",
  SET_TARGET_LIST: "SET_TARGET_LIST",
  SET_FRAGMENT_MASS: "SET_FRAGMENT_MASS",
  REVERSE_FRAGMENT_MASS: "REVERSE_FRAGMENT_MASS",
};

export const setHeldObject = (object) => {
  return { type: ActionTypes.SET_HELD_OBJECT, payload: object };
};

export const setFragmentMass = (data) => {
  return { type: ActionTypes.SET_FRAGMENT_MASS, payload: data };
};

export const reverseFragmentMass = (data) => {
  return { type: ActionTypes.REVERSE_FRAGMENT_MASS, payload: data };
};
